module.exports = __webpack_public_path__ + "media/images/pc/maedori_photowedding/spot_01-4a767b06901917f5780ff2056cafa893.webp";